import React, { Component } from 'react';
import { Modal, Form, FormGroup, Checkbox, ButtonToolbar, Button, ControlLabel } from 'react-bootstrap';
import Select from "react-select";

export class StopAdditionalInfo extends Component {
    render() {
        const { stopSelected } = this.props;

        if (undefined === stopSelected) {
            return null;
        }

        const wheelchairBoardingOptions = [{ id: 0, name: "Desconhecida" }, { id: 1, name: "Possível" }, { id: 2, name: "Indisponível" }];

        return (
            <Modal show={this.props.show}>
                <Modal.Header>
                    <Modal.Title>
                        Informação Adicional da Paragem
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup controlId="formWheelchairBoarding">
                            <ControlLabel>Capacidade de Embarque com Cadeira de Rodas</ControlLabel>
                            <Select
                                className="custom-multiselect"
                                placeholder="Selecione uma opção"
                                onChange={(e) => this.props.onChangeSelectValue(null === e ? 0 : e.id, 'wheelchairBoarding')}
                                options={wheelchairBoardingOptions}
                                isMulti={false}
                                isClearable={false}
                                getOptionValue={value => value}
                                getOptionLabel={label => label.name}
                                value={wheelchairBoardingOptions.find(o => o.id === stopSelected.wheelchairBoarding)}
                            />
                        </FormGroup>

                        <FormGroup controlId="formSlot">
                            <Checkbox className="form-checkbox" defaultChecked={stopSelected.slot} onChange={(e) => this.props.onChangeValue(e, 'slot')}>
                                Slot Dedicado na Estrada
                            </Checkbox>
                        </FormGroup>

                        <FormGroup controlId="formSignalling">
                            <Checkbox className="form-checkbox" defaultChecked={stopSelected.signalling} onChange={(e) => this.props.onChangeValue(e, 'signalling')}>
                                Sinalização Vertical
                            </Checkbox>
                        </FormGroup>

                        <FormGroup controlId="formIpSignalling">
                            <Checkbox className="form-checkbox" defaultChecked={stopSelected.ipSignalling} onChange={(e) => this.props.onChangeValue(e, 'ipSignalling')}>
                                Sinalização da Infraestruturas de Portugal
                            </Checkbox>
                        </FormGroup>

                        <FormGroup controlId="formShelter">
                            <Checkbox className="form-checkbox" defaultChecked={stopSelected.shelter} onChange={(e) => this.props.onChangeValue(e, 'shelter')}>
                                Abrigo
                            </Checkbox>
                        </FormGroup>

                        <FormGroup controlId="formBench">
                            <Checkbox className="form-checkbox" defaultChecked={stopSelected.bench} onChange={(e) => this.props.onChangeValue(e, 'bench')}>
                                Assento(s)
                            </Checkbox>
                        </FormGroup>

                        <FormGroup controlId="formNetworkMap">
                            <Checkbox className="form-checkbox" defaultChecked={stopSelected.networkMap} onChange={(e) => this.props.onChangeValue(e, 'networkMap')}>
                                Mapa da Rede Afixado
                            </Checkbox>
                        </FormGroup>

                        <FormGroup controlId="formSchedule">
                            <Checkbox className="form-checkbox" defaultChecked={stopSelected.schedule} onChange={(e) => this.props.onChangeValue(e, 'schedule')}>
                                Horários Afixados
                            </Checkbox>
                        </FormGroup>

                        <FormGroup controlId="formRealTimeInformation">
                            <Checkbox className="form-checkbox" defaultChecked={stopSelected.realTimeInformation} onChange={(e) => this.props.onChangeValue(e, 'realTimeInformation')}>
                                Informação em Tempo Real
                            </Checkbox>
                        </FormGroup>

                        <FormGroup controlId="formTariff">
                            <Checkbox className="form-checkbox" defaultChecked={stopSelected.tariff} onChange={(e) => this.props.onChangeValue(e, 'tariff')}>
                                Informação de Tarifário
                            </Checkbox>
                        </FormGroup>
                    </Form>

                    <ButtonToolbar>
                        <Button onClick={() => this.props.onHide()}>
                            CONCLUÍDO
                        </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/stops/StopAdditionalInfo.js